"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType["QualityCertificate"] = "QualityCertificate";
    DocumentType["TechnicalProject"] = "TechnicalProject";
    DocumentType["ReceiptControlAct"] = "ReceiptControlAct";
    DocumentType["DetailControlAct"] = "DetailControlAct";
    DocumentType["AcceptanceTestReport"] = "AcceptanceTestReport";
    DocumentType["ProductPassport"] = "ProductPassport";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
//# sourceMappingURL=document.type.js.map